import { Component } from '@angular/core';

@Component({
  selector: 'app-notification-success',
  templateUrl: './notification-success.component.html',
  standalone: false
})
export class NotificationSuccessComponent {}
